import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectTagsTicketIsTaggedWith } from 'flow/selectors/TicketsSelectors';
import { Tag } from 'flow/types/Tag';
import { TicketKey } from 'flow/types/EntityKeys';
import { TypedMap } from 'flow/types/TypedMap';

import TagChip from './TagChip';

type Props = {
    ticketKey: TicketKey;
    isSelected: boolean;
    muted?: boolean;
};

const TagChips = ({ ticketKey, isSelected, muted }: Props) => {
    const tagsTicketIsTaggedWith = useAppSelector((state) =>
        selectTagsTicketIsTaggedWith(state, ticketKey),
    );

    if (!tagsTicketIsTaggedWith || tagsTicketIsTaggedWith.isEmpty()) {
        return null;
    }

    return (
        <>
            {tagsTicketIsTaggedWith
                .map((tag: TypedMap<Tag>) => (
                    <TagChip
                        key={tag.get('key')}
                        label={tag.get('label')}
                        isSelected={isSelected}
                        muted={muted}
                    />
                ))
                .valueSeq()}
        </>
    );
};

export default React.memo(TagChips);
